import React from "react";
import { useTranslation } from "react-i18next";
import { formatDeltaPct } from "./intentInsightsService";
import styles from "./intentInsights.module.scss";

export default function TopIntentsCard({ intents }) {
  const { t } = useTranslation();
  if (!intents?.length) return null;

  const maxPct = Math.max(...intents.map((row) => row.pct || 0), 1);

  return (
    <article className={styles.insightCard}>
      <h3 className={styles.cardTitle}>{t("sonic_prospect.intent_insights.top_intents_title")}</h3>
      <ul className={styles.intentList}>
        {intents.map((row, index) => {
          const delta = row.deltaPct;
          const up = delta == null ? null : delta >= 0;
          return (
            <li key={row.id} className={styles.intentRow}>
              <span className={styles.intentRank}>{index + 1}</span>
              <div className={styles.intentMain}>
                <div className={styles.intentLabelRow}>
                  <span className={styles.intentName}>{row.label}</span>
                  <span className={styles.intentPct}>{row.pct}%</span>
                </div>
                <div className={styles.intentBarTrack}>
                  <div
                    className={styles.intentBarFill}
                    style={{ width: `${Math.round((row.pct / maxPct) * 100)}%` }}
                  />
                </div>
                <div className={styles.intentMeta}>
                  <span>
                    {t("sonic_prospect.intent_insights.intent_conversations", {
                      count: row.count,
                    })}
                  </span>
                  <span className={up ? styles.deltaUp : styles.deltaDown}>
                    {formatDeltaPct(delta)}{" "}
                    {t("sonic_prospect.intent_insights.vs_last_week")}
                  </span>
                </div>
              </div>
            </li>
          );
        })}
      </ul>
    </article>
  );
}
